export default __webpack_public_path__ + "static/media/us-flag.b9dacc70.png";